import React, { lazy } from 'react'

export const componentMap: {[key:string]: React.FC} = {

  // 这条注释用于代码自动生成, 切勿修改
}
